import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Reports|Downloadable Reports|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ReportsStandard,
	portal: 'SP',
};

export type SPDownloadableReportsLocNames =
	| 'SPDownloadableReportsTitleTab'
	| 'SPDownloadableReportsTitlePage'
	| 'SPDownloadableReportsSectionTitle'
	| 'SPDownloadableReportsLabelUser'
	| 'SPDownloadableReportsLabelReport'
	| 'SPDownloadableReportsLabelComments'
	| 'SPDownloadableReportsLabelDateRun'
	| 'SPDownloadableReportsLabelSize'
	| 'SPDownloadableReportsButtonDownload'
	| 'SPDownloadableReportsButtonDelete'
	| 'SPDownloadableReportsMessageDeleteConfirmation';

export const spDownloadableReportsLocs: LocDefs<SPDownloadableReportsLocNames> = {
	SPDownloadableReportsTitleTab: {
		defaultValue: 'Downloadable Reports',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'Reports.Standard/Reporting.DownloadableReports.Title.TabTitle',
		...sharedProperties,
	},
	SPDownloadableReportsTitlePage: {
		defaultValue: 'Downloadable Reports',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Reports.Standard/Reporting.DownloadableReports.Title.PageTitle',
		...sharedProperties,
	},
	SPDownloadableReportsSectionTitle: {
		defaultValue: 'Reports',
		description: 'Section Title',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		legacyName: 'Reports.Standard/Reporting.DownloadableReports.Title.SectionTitle',
		...sharedProperties,
	},
	SPDownloadableReportsLabelUser: {
		defaultValue: 'User',
		description: 'Label for User column',
		displayPath: `${pathStart}User`,
		displayType: 'Label',
		legacyName: 'Reports.Standard/Reporting.DownloadableReports.ColumnHeading.User',
		...sharedProperties,
	},
	SPDownloadableReportsLabelReport: {
		defaultValue: 'Report',
		description: 'Label for Report column',
		displayPath: `${pathStart}Report`,
		displayType: 'Label',
		legacyName: 'Reports.Standard/Reporting.DownloadableReports.ColumnHeading.Report',
		...sharedProperties,
	},
	SPDownloadableReportsLabelComments: {
		defaultValue: 'Comments',
		description: 'Label for Comments column',
		displayPath: `${pathStart}Comments`,
		displayType: 'Label',
		legacyName: 'Reports.Standard/Reporting.DownloadableReports.ColumnHeading.Comments',
		...sharedProperties,
	},
	SPDownloadableReportsLabelDateRun: {
		defaultValue: 'Date Run',
		description: 'Label for Date Run column',
		displayPath: `${pathStart}Date Run`,
		displayType: 'Label',
		legacyName: 'Reports.Standard/Reporting.DownloadableReports.ColumnHeading.DateRun',
		...sharedProperties,
	},
	SPDownloadableReportsLabelSize: {
		defaultValue: 'Size (KB)',
		description: 'Label for Size column',
		displayPath: `${pathStart}Size`,
		displayType: 'Label',
		legacyName: 'Reports.Standard/Reporting.DownloadableReports.ColumnHeading.Size',
		...sharedProperties,
	},
	SPDownloadableReportsButtonDownload: {
		defaultValue: 'Download',
		description: 'Button text for downloading a report',
		displayPath: `${pathStart}Download Button`,
		displayType: 'Button',
		legacyName: 'Reports.Standard/Reporting.DownloadableReports.Button.Download',
		...sharedProperties,
	},
	SPDownloadableReportsButtonDelete: {
		defaultValue: 'Delete',
		description: 'Button text for deleting a report',
		displayPath: `${pathStart}Delete Button`,
		displayType: 'Button',
		legacyName: 'Reports.Standard/Reporting.DownloadableReports.Button.Delete',
		...sharedProperties,
	},
	SPDownloadableReportsMessageDeleteConfirmation: {
		defaultValue: 'Are you sure you want to delete this report?',
		description: 'Message for deleting a report',
		displayPath: `${pathStart}Delete Confirmation Message`,
		displayType: 'Content',
		legacyName: 'Reports.Standard/Reporting.DownloadableReports.Content.DeleteConfirmation',
		...sharedProperties,
	},
};

export type SPDownloadableReportsLocType = LocMap<SPDownloadableReportsLocNames>;
